const MODAL_TIMEOUT = 1500

const state = () => ({
  modal: {
    isVisible: false,
    canCloseOutside: false,
    withoutShadow: false,
    size: '',
    name: '',
    timeout: MODAL_TIMEOUT,
    data: {},
    options: {}
  }
})

const getters = {
  modal (state) {
    return state.modal
  }
}

const actions = {
  showModal ({ commit }, modal) {
    commit('setVisible', true)
    commit('setCloseOutsideState', modal.canCloseOutside)
    commit('setWithoutShadow', modal.withoutShadow)
    commit('setSize', modal.size)
    commit('setName', modal.name)
    commit('setTimeout', modal.timeout)
    commit('setData', modal.data ? modal.data : {})
    commit('setOptions', modal.options ? modal.options : {})
  },
  closeModal ({ commit }) {
    commit('setVisible', false)
    commit('setCloseOutsideState')
    commit('setWithoutShadow', false)
    commit('setSize')
    commit('setName', '')
    commit('setTimeout', MODAL_TIMEOUT)
    commit('setData', {})
    commit('setOptions', {})
  }
}

const mutations = {
  setVisible (state, visible) {
    state.modal.isVisible = visible
  },
  setCloseOutsideState (state, closeState) {
    state.modal.canCloseOutside = closeState || false
  },
  setWithoutShadow (state, withoutShadow) {
    state.modal.withoutShadow = withoutShadow || false
  },
  setSize (state, size = '700px') {
    state.modal.size = size
  },
  setName (state, name) {
    state.modal.name = name
  },
  setTimeout (state, timeout = MODAL_TIMEOUT) {
    state.modal.timeout = timeout
  },
  setData (state, data) {
    state.modal.data = data
  },
  setOptions (state, options) {
    state.modal.options = options
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
